import type { IntlShape } from 'react-intl'

export function descriptionBuilder(
  name: string,
  price: number,
  value: number,
  brand: string,
  brandTitle: string,
  intl: IntlShape,
) {
  const formattedBrand = (brand === 'luxuryescapes') ? `${brandTitle} Travel` : brandTitle

  if (price && value && price !== value) {
    const percent = Math.round((1 - price / value) * 100)
    return intl.formatMessage(
      {
        id: 'xUjyoCnQD3QJ8MeT74oi',
        defaultMessage: 'Today’s {formattedBrand} Deal: {name}. Buy Now & Save {percent}% on {formattedBrand} Deals.',
      },
      {
        formattedBrand,
        name,
        percent,
      },
    )
  } else {
    return intl.formatMessage(
      {
        id: 'eOujk9awXf3_4Zyzm2MM',
        defaultMessage: 'Today’s {formattedBrand} Deal: {name}.',
      },
      {
        formattedBrand,
        name,
      },
    )
  }
}
